import { take } from 'redux-saga/effects';

import store from 'Store';
import { CHECK_MOBILE_SETTING, INITIALIZE_MOBILE_SETTING } from './actions';


function initializeMobileSettings(event) {
  store.dispatch({
    type: CHECK_MOBILE_SETTING,
    data: event.target.innerWidth
  });
}

function* initialize() {
  yield take(INITIALIZE_MOBILE_SETTING);
  window.addEventListener('resize', initializeMobileSettings, false);
}


export default initialize;
